import {useAppDispatch,useAppSelector} from '@/store'
import {useEffect, useState} from 'react'
import {useLocation} from 'react-router-dom'
import {FileUploadWithoutModal} from '@/components/organisms/FileUploadWithoutModal'

import {downloadTemplateFile, TEMPLATE_TYPE} from '@/services/downloadTemplateFile'
import { Constants} from '@/utils/constants/commonConstants'

import {uploadFileDescriptionForCSV} from '@/utils/commonTemplate'

import {downloadCSVFiles, getDateWithTimeString} from '@/helpers/shadcn/utils'
import { setPointMultiplierFormData } from '@/store/slices/pointMultiplier'
export const ProductsPointMultiplierSection = ({
  formData,
  setFormData,
  setDisableNext
}) => {
  const location = useLocation()
  const dispatch = useAppDispatch()
  const [uploadError, setUploadError] = useState(false)
  const pointMultiplier = useAppSelector(state => state?.pointMultiplier)
  const prefillData = location.state?.formData
  const customRules  = {
    type: 'text/csv',
    size: 25600,
    columns: [
      {
        name: 'Product ID',
        required: true,
        type: 'alphanumeric',
        minChar: 1,
        maxChar: 255,
        unique: true
      },
      {
        name: 'Point Multiplier',
        required: true,
        type: 'number',
      }
    ],
  }
  
  // const [rulesC, setRulesC] = useState(rulesCriteriaJsonSchema.properties?.rulesCriteria?.options)
  const handleFileDownload = async () => {
   const body = { type: TEMPLATE_TYPE.POINT_MULTIPLIER }
    let response = await downloadTemplateFile(body)
    if (!response) return
    const fileName = `PointMultiplierProductTemplate_${getDateWithTimeString()}`
    downloadCSVFiles(response, fileName)
  }

  useEffect(() => {
    if (prefillData) {
      setFormData({
        ...prefillData,
      })
    }
  }, [prefillData, setFormData])

  useEffect(() => {
    const flag = pointMultiplier?.uploadOutcome?.totalCount>0;
    setDisableNext(!flag)
  } , [pointMultiplier, setDisableNext])
    const handleDelete = () => {
      setFormData({...formData, mediaFile: [], })
      dispatch(setPointMultiplierFormData({...formData,uploadOutcome: {}, mediaFile: []}))
      // dispatch(resetRuleSet())
    }
    const onValidatedFileName = fileName => {
    setFormData((prev)=> { 
        return {...prev,  mediaFile: [fileName]}});
      dispatch(setPointMultiplierFormData({...formData, mediaFile: [fileName]}))
    }
    const handleValidateProductIds = response => {
      if(response.data){
        setUploadError(false)
      }
      setFormData((prev)=>{ return { ...prev,    uploadOutcome:{
        activeTab: 'productsPointMultiplier',
        totalCount: response.totalProductIds,
        nonExistentIds: response.data,
        fileName: response.fileName
        }}})
      dispatch(setPointMultiplierFormData({
        uploadOutcome:{
        activeTab: 'productsPointMultiplier',
        totalCount: response.totalProductIds,
        nonExistentIds: response.data,
        fileName: response.fileName
        }
      }));
    if (onValidatedFileName && response.fileName) {
      onValidatedFileName(response.fileName);
    }
  }
  return (
    <div>
       <FileUploadWithoutModal
                    activeTab={'productsPointMultiplier'}
                    key={'products'}
                    handleDownloadTemplate={handleFileDownload}
                    handleViewTable={() => { }}
                    headerTitle={'Products'}
                    description={uploadFileDescriptionForCSV()}
                    acceptedExtensions={Constants.CSV}
                    files={formData.mediaFile?.length > 0 ? formData.mediaFile : []}
                    // onUpload={file => {
                    //   console.log('file***', file);
                    //   // setFormData({...formData,  mediaFile: [file?.name] })
                    //   // dispatch(setPointMultiplierFormData(formData))
                    //   setUploadError(false)
                    // }}
                    feedbackType={uploadError ? Constants.Error : Constants.Info}
                    helperText={uploadError ? 'Upload Error: Please use only .CSV file type' : ''}
                    onUploadError={error => {
                      if (error) {
                        setUploadError(true)
                      }
                    }}
                    onUploadDelete={handleDelete}
                    variant={formData.mediaFile?.length > 0 ? Constants.Complete : Constants.Edit}
                    type={Constants.Single}
                    className="!max-w-full"
                    containerClassName="!w-full"
                    isCsvValidationRequired={true}
                    required={ false }
                    showDownloadTemplate={true}
                    isValidateProductIds={true}
                    customRules={customRules}
                    productIdsFilename={formData.mediaFile?.[0]}
                    onValidatedFileName={()=>{}}
                    handleValidateProductIds={handleValidateProductIds}
                    handleUploadDelete={handleDelete}
                    uploadResult ={ pointMultiplier?.uploadOutcome}
                  />
    </div>
  )
}
